/**
 * Workshop Scheduled - Refresh button handler
 *
 * Listens for click on the "Atualizar lista" button (#btn-refresh-scheduled)
 * and triggers a POST to the refresh endpoint (read from data-refresh-url).
 */
document.addEventListener("DOMContentLoaded", function () {
  var btn = document.getElementById("btn-refresh-scheduled");
  if (!btn) return;

  var icon = document.getElementById("refresh-icon");
  var spinner = document.getElementById("refresh-spinner");
  var refreshUrl = btn.dataset.refreshUrl;

  btn.addEventListener("click", function () {
    btn.disabled = true;
    icon.classList.add("d-none");
    spinner.classList.remove("d-none");

    fetch(refreshUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
        Accept: "application/json",
      },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data.ok) {
          btn.innerHTML =
            '<span class="mdi mdi-check mr-1"></span>' + data.message;
          btn.classList.remove("btn-secondary");
          btn.classList.add("btn-success");
          setTimeout(function () {
            window.location.reload();
          }, 30000);
        } else {
          alert("Erro ao iniciar atualização.");
          resetBtn();
        }
      })
      .catch(function (err) {
        alert("Erro de comunicação com o servidor.");
        console.error("refreshScheduled:", err);
        resetBtn();
      });
  });

  function resetBtn() {
    btn.disabled = false;
    icon.classList.remove("d-none");
    spinner.classList.add("d-none");
  }
});
